import React from "react";
import { useLocation } from "react-router-dom";

import CollectionBreadcrumbs from "../../components/collections/CollectionBreadcrumbs";
import { useIsMobile, useCurrentFullAssistantPage } from "@hooks";
import { COLLECTION_PAGES } from "@consts";
import { hiddenTitlePages } from "@utils";
import { TopContainer } from "../LayoutWrappers";
import MobileNavigationBar from "../Navigation/MobileNavigationBar";
import PageTitle from "../PageTitle";

const AssistantHeader = props => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const showCollectionBreadcrumbs = COLLECTION_PAGES.some(page => location?.pathname.includes(page));
  const hideTitle = hiddenTitlePages.some(page => location?.pathname.includes(page));

  if (hideTitle) return null;
  return (
    <TopContainer showBreadcrumbs={showCollectionBreadcrumbs} statusBarDisplayed={props?.showStatusBar}>
      {isMobile && <MobileNavigationBar {...props} useCurrentPage={useCurrentFullAssistantPage} />}
      {showCollectionBreadcrumbs ? <CollectionBreadcrumbs /> : <PageTitle />}
    </TopContainer>
  );
};

export default AssistantHeader;
